/* eslint-disable camelcase */
export function selectTheme(theme, { getColor }) {
  return {
    getCSS: ({ color, fullWidth, value, border, isValid, __internal__focus }) => {
      const focusStyle = {
        outline: 0,
        borderRadius: theme.radii[1],
        borderColor: theme.colors.midBlue.t1000,
        borderStyle: 'Solid',
        borderWidth: theme.borderWidths[0],
      };

      const errorStyle = {
        outline: 0,
        borderRadius: theme.radii[1],
        borderColor: theme.colors.conditional.negative.graphics,
        borderStyle: 'Solid',
        borderWidth: theme.borderWidths[0],
      };

      return {
        display: 'inline-block',
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights.medium,
        lineHeight: theme.lineHeights[2],
        fontFamily: theme.fonts.body,
        color: value === '' ? theme.colors.grey.t65 : theme.colors.black,
        width: fullWidth ? '100%' : null,
        height: '48px',
        paddingLeft: theme.space[4],
        paddingRight: theme.space[10],
        margin: 0,
        border,
        borderRadius: theme.radii[1],
        appearance: 'none',
        backgroundColor: getColor(color),
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath d='M22.646 14.98l-5.854 5.697c-.442.43-1.143.43-1.585 0l-5.85-5.693a1.153 1.153 0 01.473-1.94c.395-.112.82-.002 1.107.284l5.062 4.928 5.057-4.922c.33-.33.824-.425 1.25-.242a1.15 1.15 0 01.34 1.888z' fill='%23000000'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `right ${theme.space[4]} top 50%`,
        alignSelf: 'flex-start',
        // See: https://stackoverflow.com/a/19451423/247243
        ':-moz-focusring': {
          color: 'transparent',
          textShadow: '0 0 0 #000',
        },
        ':focus': isValid && focusStyle,
        ...(!isValid && errorStyle),
        ...(__internal__focus && focusStyle),
      };
    },
  };
}
